import API from "./axios";
import { IProject, IProjectsResponse, IProjectStats, IQueryParams } from "../types/project";

export const getProjects = async (): Promise<IProject[]> => {
	const response = await API.get("/projects");
	return response.data.projects || response.data;
};

export const getProjectsWithPagination = async (params?: IQueryParams): Promise<IProjectsResponse> => {
	const response = await API.get("/projects", { params });
	return response.data;
};

export const getFeaturedProjects = async (): Promise<IProject[]> => {
	const response = await API.get("/projects/featured");
	return response.data;
};

export const getProject = async (id: string): Promise<IProject> => {
	const response = await API.get(`/projects/${id}`);
	return response.data;
};

export const createProject = async (data: FormData): Promise<IProject> => {
	const response = await API.post("/projects", data, {
		headers: {
			"Content-Type": "multipart/form-data",
		},
	});
	return response.data;
};

export const updateProject = async (id: string, data: FormData): Promise<IProject> => {
	const response = await API.put(`/projects/${id}`, data, {
		headers: {
			"Content-Type": "multipart/form-data",
		},
	});
	return response.data;
};

export const toggleFeaturedProject = async (id: string, featured: boolean): Promise<IProject> => {
	const response = await API.put(`/projects/${id}/featured`, { featured });
	return response.data;
};

export const deleteProject = async (id: string): Promise<{ message: string }> => {
	const response = await API.delete(`/projects/${id}`);
	return response.data;
};

export const getCategories = async (): Promise<string[]> => {
	const response = await API.get("/projects/categories");
	return response.data;
};

export const getTechnologies = async (): Promise<string[]> => {
	const response = await API.get("/projects/technologies");
	return response.data;
};

export const getProjectStats = async (): Promise<IProjectStats> => {
	const response = await API.get("/projects/stats");
	return response.data;
};